import { LoadingSpinner } from '@opengov/component-library/dist';
import { OgGridTable, IOgGridTableProps } from '@opengov/components-og-grid-table';
import React from 'react';

import { IReportLocale } from '../../../../../application/common/locale';
import { DataTableStatus } from '../../../../reportExplorer/types';

import styles from './CalculationPreviewTable.scss';

export interface ICalculationPreviewTable {
  reportMessages: IReportLocale;
  calculationPreviewTableStatus: DataTableStatus;
  calculationPreviewTableProps: IOgGridTableProps;
}

export const CalculationPreviewTable: React.FC<ICalculationPreviewTable> = (props) => {
  const {
    calculationPreviewTableProps,
    calculationPreviewTableStatus,
    reportMessages: {
      calculations: {
        basicCalculationModal: { loadingPreview }
      }
    }
  } = props;
  return calculationPreviewTableStatus === DataTableStatus.Current &&
    calculationPreviewTableProps.rowData.length > 0 ? (
    <OgGridTable {...calculationPreviewTableProps} />
  ) : (
    <div className={styles.loadingWrapper}>
      <LoadingSpinner dataTest="data-table-updating-indicator" message={loadingPreview} />
    </div>
  );
};
